import { useState, useCallback, useMemo, useRef } from 'react';
import { usePostShare } from '../../utils/queryHooks';

const { baseUrl } = window.conviva;

export const useShare = ({
  interval,
  clientId,
  viewerId,
  source,
  globalFilters,
  idType,
  eventNames,
  flowId,
}) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [id, setId] = useState<string>('');
  const prevReqBody = useRef<any>(null);
  const { mutate: postShare, isLoading: isFetching } = usePostShare();

  const handleVisibleChange = useCallback((newVisible: boolean) => {
    setVisible(newVisible);
  }, []);

  const startTime = useMemo(() => (interval as string).split('/')[0], [interval]);
  const endTime = useMemo(() => (interval as string).split('/')[1], [interval]);

  const reqBody = useMemo(
    () => ({
      title: flowId ? `Flow User Timeline ${interval}` : `User Timeline ${interval}`,
      dashboard: 'user-timeline',
      start: startTime,
      end: endTime,
      state: {
        clientId,
        viewerId,
        interval,
        source,
        globalFilters,
        idType,
        eventNames,
        flowId,
      },
    }),
    [
      interval,
      startTime,
      endTime,
      clientId,
      viewerId,
      source,
      globalFilters,
      idType,
      eventNames,
      flowId,
    ],
  );

  const url = `${baseUrl}/dashboard/user-timeline/sharing`;

  const openShare = useCallback(() => {
    setVisible(true);
    if (prevReqBody.current === reqBody) {
      return;
    }
    prevReqBody.current = reqBody;
    postShare(reqBody, {
      onSuccess: (data) => {
        setId(data);
      },
    });
  }, [postShare, reqBody]);

  return {
    visible,
    isFetching,
    url,
    id,
    openShare,
    handleVisibleChange,
  };
};
